import React, { FC } from 'react';
import styles from '../StoreReadyStep.scss';
import { StoreReadyStepContent } from './StoreReadyStepContent';
import { useAppStore } from 'stores/appStore';

export const StoreReadyStepMobile: FC = () => {
  const siteUrl = useAppStore((state) => state.siteUrl);

  return (
    <div className={styles.storeReadyStepMobile}>
      <StoreReadyStepContent />
      <div className={styles.storeReadyStepMobilePreview}>
        <iframe src={siteUrl} title={siteUrl} />
      </div>
    </div>
  );
};
